import React, { Component } from 'react';
import Conf from '../../../../utils/Conf';
import { getRequest, postRequest } from '../../../../utils/WebServicesManager';
import { getDateStr } from '../../../../utils/Utils';
import { translate, exists } from '../../../../utils/ReactMultiLang';
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import 'react-table/react-table.css';
import diff from 'deep-diff';

class GPSSensorsTable extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 10,
      loading: false,
      selection: [],
      selectAll: false
    };
    this.CheckboxTable = checkboxHOC(ReactTable);
    this.fetchData = this.fetchData.bind(this);
    this.updateSensors = props.updateSensors;
    this.t = props.t;
  }

  requestData(pageSize, page, sorted, filtered) {
    return new Promise((resolve, reject) => {
      var url = Conf.BaseApi + 'devices/getSorted/GPS';

      postRequest(url, {pageSize, page, sorted, filtered, DevEUI: this.state.DevEUI}, (data) => {
        if (data.success) {
          const res = {
            rows: data.result.rows,
            pages: data.result.pages
          };
          resolve(res);
        } else {
          reject(new Error(data.message))
        }
      });
    });
  }

  fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    if (!state) state = this.state.dataParam;

    this.requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.updateSensors(res.rows);
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false,
        dataParam: state
      });
    });
  }

  render() {
    const { pages, loading, selectAll } = this.state;
    const columns = this.getColumns();

    const checkboxProps = {
      selectAll: selectAll,
      isSelected: this.isSelected.bind(this),
      toggleSelection: this.toggleSelection.bind(this),
      toggleAll: this.toggleAll.bind(this),
      selectType: "checkbox",
      getTrProps: (s, r) => {
        // someone asked for an example of a background color change
        // here it is...
        if (r) {
          const selected = this.isSelected(r.original._id);
          return {
            style: {
              backgroundColor: selected ? "#0CF2B3" : "inherit"
              // color: selected ? 'white' : 'inherit',
            }
          };
        }
        return { style: {backgroundColor: "inherit"} };
      }
    };
    return (
        <div className="col-lg-12 col-md-12">
        <this.CheckboxTable
              filterable={true}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]).includes(filter.value)}
              data={this.state.data}
              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
              pages={pages} // Display the total number of pages
              loading={loading}
              ref={r => (this.checkboxTable = r)}
              onFetchData={this.fetchData}
              columns={columns}
              building={this.state.buildingId}
              defaultPageSize={20}
              className="-striped -highlight"
              {...checkboxProps}
            />
        </div>
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (diff(nextState, this.state) ? true : false);
  }


  /** React-table */
  
  getColumns() {
    return [
      { id: 'name', accessor: d => <a href={`#/sensors/detail?deveui=${d.DevEUI}`}>{d.name}</a>, Header: this.t('Name') }, 
      { id: "usage", accessor: d => d.usage ? d.usage : '', Header: this.t('Usage') }, 
      { Header: this.t('Tags'), id: "groups", accessor: d => d.groups ? d.groups.join(', ') : '' },
      { id: "lastSeen", 
        maxWidth: 150,
        accessor: d => d.lastSeen ? getDateStr(new Date(d.lastSeen).getTime()) : '',
        Header: this.t('Message.Time') 
      }, { id: 'status', 
        accessor: d => <span className={(d.status === 'ACTIF') ? 'badge badge-success' : (d.status === 'NOSIGNAL') ? 'badge badge-danger' : 'badge badge-default'}>{this.t(d.status)}</span>,
        Header: this.t('Status'), maxWidth: 100 }
    ];
  }

  toggleSelection(key, shift, row) {
    /*
      Implementation of how to manage the selection state is up to the developer.
      This implementation uses an array stored in the component state.
      Other implementations could use object keys, a Javascript Set, or Redux... etc.
    */
    // start off with the existing state
    let selection = [...this.state.selection];
    const keyIndex = selection.indexOf(row._id);
    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
    } else {
      // it does not exist so add it
      selection.push(row._id);
    }
    // update the state
    this.setState({ selection });
    if (selection.length > 0) {
      this.updateSensors(this.state.data.filter(r => selection.includes(r._id)));
    } else {
      this.updateSensors(this.state.data);
    }
  };

  toggleAll() {
    const selectAll = this.state.selectAll ? false : true;
    const selection = [];
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach(item => {
        selection.push(item._original._id);
      });
    }
    this.setState({ selectAll, selection });
  };


  isSelected(key) {
    /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
    return this.state.selection.includes(key);
  };

}

export default translate(GPSSensorsTable);


// WEBPACK FOOTER //
// ./src/views/Sensors/GPSSensors/GPSSensorsTable/GPSSensorsTable.js